var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('media-uploader',{ref:"mediaUploader",on:{"uploads":_vm.updateUploads,"valid":_vm.emitValid,"saving":_vm.handleSaving},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return undefined}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }